import React from 'react';
import Shape3D from 'react-paella-shape-isometric';
import { colors } from '../styles';

const Logo = () => {
  return (
    <>
      <h1 className="offscreen">Padel+</h1>
      <div
        style={{
          overflow: 'hidden',
          borderRadius: '50%',
          width: '100px',
          height: '100px',
        }}
      >
        <Shape3D.Cube
          a11yTitle="logo is a cube"
          scaling={0.5}
          boundaryX={-25}
          boundaryY={20}
          borderColor={colors.ultrablack}
          chartBg={colors.highlight}
        />
      </div>
    </>
  );
};

export default Logo;
